module.exports = __webpack_public_path__ + "img/instancetime.547c3977.svg";